import React, { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { Lock, Mail, LogIn, ArrowLeft } from "lucide-react";
import { useAuth, formatApiError } from "../AuthContext";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await login(email.trim(), password);
      navigate("/admin", { replace: true });
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen navy-gradient-soft grain flex items-center justify-center p-6" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <a href="/" className="inline-flex items-center gap-2 text-white/70 hover:text-[#FF8C42] text-[13px] font-semibold transition-colors" data-testid="admin-login-back">
          <ArrowLeft size={14} /> Înapoi la site
        </a>
        <div className="mt-6 soft-card p-8 bg-white">
          <div className="flex items-center gap-3">
            <img src="/brand/marioway-logo.png" alt="Marioway" width={44} height={44} style={{ objectFit: "contain" }} />
            <div>
              <div className="font-display text-2xl text-[#002B7F]">Panou Admin</div>
              <div className="text-[12.5px] text-[#4A4A4A]">Marioway Benefits Consultancy Ltd</div>
            </div>
          </div>
          <form onSubmit={onSubmit} className="mt-8 space-y-4" data-testid="admin-login-form">
            <label className="block">
              <span className="text-[13px] font-bold text-[#002B7F] inline-flex items-center gap-1.5"><Mail size={13} /> E-mail</span>
              <input type="email" className="input-field mt-2" value={email} onChange={(e) => setEmail(e.target.value)} autoComplete="username" required data-testid="admin-login-email" />
            </label>
            <label className="block">
              <span className="text-[13px] font-bold text-[#002B7F] inline-flex items-center gap-1.5"><Lock size={13} /> Parolă</span>
              <input type="password" className="input-field mt-2" value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="current-password" required data-testid="admin-login-password" />
            </label>
            {error && <div className="rounded-xl bg-[#FDECEC] border border-[#F5C2C2] text-[#A11] text-[13px] p-3" data-testid="admin-login-error">{error}</div>}
            <button type="submit" disabled={busy} className="btn-orange w-full justify-center disabled:opacity-70" data-testid="admin-login-submit">
              <LogIn size={16} /> {busy ? "Se conectează…" : "Conectare"}
            </button>
          </form>
          <p className="mt-6 text-[11.5px] text-[#6B7280] leading-relaxed">Acces restricționat. Zona este destinată exclusiv administratorului Marioway.</p>
        </div>
      </div>
    </div>
  );
}
